module.exports = __webpack_public_path__ + "img/2b4138715e65f3b281b7f52626c13a8.6fd6b1cb.png";